import { Id, BaseItem } from 'types';
import { Note } from 'types/entity';
import { CondominioID } from './condominio';

export type IncaricoCondominoParameters = { condominioID?: number; personaID?: number };

export type IncaricoCondomino = Id &
  Note & {
    anagraficaIncarico: BaseItem;
    tipoIncarico: BaseItem;
    condominio: BaseItem;
  };

export type EditIncaricoCondomino = Partial<Note> &
  CondominioID & {
    anagraficaIncaricoId: number;
    tipoIncaricoId: number;
  };

export type CreaIncaricoCondomino = Partial<EditIncaricoCondomino>;

export enum TipoAnagraficaEnum {
  AnagraficaCondominio = 1,
  Persona,
  Fornitore
}

export type AnagraficaIncarico = BaseItem & { tipoAnagrafica: TipoAnagraficaEnum };
